import React from 'react';
import { motion } from 'framer-motion';
import Logo from '../../../assets/boost-logo.svg';
import Correct from '../../../assets/correct.svg';
import Flag from '../../../assets/flag.svg';
import Layout from '../../../assets/layout.svg';
import Switch from '../../../assets/switch.svg';
import ButtonBoost from "./ButtonBoost";
import Button from '../../../components/ui/buttons/Button';
import CheckListItem from '../../../components/ui/CheckListItem';

const containerVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.8,
            staggerChildren: 0.2
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
};

const pretupClientSpace = process.env.REACT_APP_USER_DASHBOARD;

const Boost = () => {
    return (
        <div className="mb-12 md:mb-14">
            <h2 className={`text-4xl font-bold text-white bg-secondary py-3 rounded-lg text-center`}>Boost PretUp : la gestion pilotée de vos prêts PME​</h2>
            <div className="text-center mt-4 mb-6 text-gray-600">
                <p>Avec <strong>Boost PretUp</strong>, confiez la gestion de vos investissements à une plateforme experte, agréée <strong>PSFP & GIPP</strong>, et accédez simplement à la dette privée des PME françaises.<br />
                </p>
            </div>
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={containerVariants}
            >
                <motion.h3
                    variants={itemVariants}
                    className='text-3xl font-bold text-yellow-500 text-center mb-4'
                >
                    Investissez sans y penser dès 20€, nous gérons pour vous.
                </motion.h3>
                <motion.div
                    className="mx-auto w-full md:w-4/5 mb-14 flex flex-wrap bg-white border-2 border-yellow-300 rounded-lg p-8 shadow-2xl"
                    variants={itemVariants}
                >
                    <div
                        className="w-full sm:w-1/3 px-4 mb-8 flex flex-col items-center text-center"
                    >
                        <img src={Logo} alt="boost-pretup" className="w-30 h-30 mb-4" />
                        <h2 className="text-2xl font-bold text-black mb-4">
                            Diversifiez automatiquement votre portefeuille de prêts.
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Prêtez automatiquement sur les projets qui correspondent aux critères que vous avez sélectionnés.
                        </p>
                        <ButtonBoost />
                    </div>
                    <motion.div
                        className="w-full sm:w-2/3 px-4 flex flex-wrap items-center justify-center"
                        variants={containerVariants}
                    >
                        {[{ img: Correct, text: "Service gratuit" }, { img: Flag, text: "Facile d’utilisation" }, { img: Layout, text: "Diversification des prêts" }, { img: Switch, text: "Désactivable à tout moment" }].map((item, index) => (
                            <motion.div
                                key={index}
                                className="w-1/2 px-4 mb-8 flex flex-col items-center text-center"
                                variants={itemVariants}
                            >
                                <img src={item.img} alt={item.text} className="w-16 h-16 mb-4" />
                                <h3 className="text-lg font-medium text-gray-700">{item.text}</h3>
                            </motion.div>
                        ))}
                    </motion.div>
                    <p className='text-gray-600 text-xs italic text-center'>
                        PretUp est Prestataire de Services de Financement Participatif (PSFP) agréé et propose un service de Gestion Individuelle de Portefeuille de Prêts (GIPP) conformément
                        à la réglementation européenne (une gestion encadrée réglementairement, une sélection des projets selon une politique de risque formalisée, une transparence accrue pour les investisseurs, des obligations renforcées de gouvernance et de gestion des conflits d’intérêts)
                        <br />
                        L’investissement en financement participatif comporte un risque de perte en capital et de liquidité
                    </p>
                </motion.div>
            </motion.div>
            <motion.div
                className="flex flex-col"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={containerVariants}
            >
                <h3 className="text-3xl font-bold text-yellow-500 text-center mb-8">Pourquoi choisir Boost PretUp ?</h3>
                <motion.ul
                    className="mb-6 grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-6"
                    variants={containerVariants}
                >
                    {[
                        { title: "Automatisation intelligente", text: "Votre capital est investi automatiquement selon des règles définies et contrôlées." },
                        { title: "Diversification renforcée", text: "Répartition sur plusieurs entreprises, secteurs et durées." },
                        { title: "Sélectivité élevée", text: "Accès uniquement aux projets rigoureusement sélectionnés et validés par l’équipe d’analystes PretUp." },
                        { title: "Gestion du risque maîtrisée", text: "10 ans d’expertise dans le financement des PME." },
                        { title: "Transparence totale", text: "Suivi clair des investissements, performances et remboursements." }
                    ].map((item, index) => (
                        <motion.li key={index} className="flex flex-col" variants={itemVariants}>
                            <CheckListItem title={item.title} text={item.text} />
                        </motion.li>
                    ))}
                </motion.ul>
                <motion.div
                    className="flex flex-col items-center text-center"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={containerVariants}
                >
                    <p
                        className="text-xl font-semibold text-gray-800 mb-6"
                        variants={containerVariants}
                    >💡Vous gagnez du temps, vous diversifiez mieux, vous investissez avec méthode</p>
                    <Button link={{ external: true, href: `${pretupClientSpace}/login.php` }} tailwindClass="bg-yellow-500 text-white" text={"Passer à l'investissement piloté"} />
                </motion.div>
            </motion.div>
        </div>
    );
}

export default Boost;